import { nanoid } from "nanoid";

export default function getRandomFileName() {
  // return nanoid(10);
  return nanoid();
}
